import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Check } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-24 px-4 bg-warmwhite" data-id="element-273">
      <div className="max-w-5xl mx-auto" data-id="element-274">
        <div className="text-center mb-16" data-id="element-275">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-green mb-4" data-id="element-276">
            Elegí tu opción
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-start" data-id="element-277">
          {/* OPCIÓN 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white border-2 border-green rounded-3xl p-8 relative shadow-lg" data-id="element-278">
            <div className="text-center mb-6" data-id="element-279">
              <span className="text-green font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-280">
                OPCIÓN 1
              </span>
              <h3 className="text-2xl font-serif font-bold text-ink mb-2" data-id="element-281">
                Mega Pack Industrialización de Alimentos en el Aula
              </h3>
              <p className="text-slate text-sm" data-id="element-282">
                Sistema completo para planificar, enseñar y evaluar todo el año
              </p>
            </div>

            <ul className="space-y-3 mb-8" data-id="element-283">
              {['Tomo 1 — Las Bases del Taller Profesional', 'Tomo 2 — De la Materia Prima a la Conservación', 'Tomo 3 — Tecnología de Lácteos y Cárnicos', 'Tomo 4 — Del Envase al Consumidor', 'Tomo 5 — Del Taller al Emprendimiento', 'Banco de paquete de actividades Adicionales', 'Banco de Evaluaciones', 'Recetario Técnico de Referencia', 'Proyectos Productivos Extra', 'Acceso inmediato', 'Garantía 7 días'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-ink" data-id="element-284">
                  <Check size={16} className="text-green shrink-0 mt-0.5" data-id="element-285" />
                  <span data-id="element-286">{item}</span>
                </li>)}
            </ul>

            <div className="text-center mb-8" data-id="element-287">
              <p className="text-4xl font-bold text-green" data-id="element-288">USD 19,90</p>
            </div>

            <Button href="https://latam.ebookemprende.shop/cart/45939810042042:1" variant="green" className="w-full" onLinkClick={() => {
            if (typeof window !== 'undefined' && (window as any).fbq) {
              ;
              (window as any).fbq('track', 'InitiateCheckout', {
                content_name: 'Mega Pack Industrialización de Alimentos en el Aula',
                value: 19.9,
                currency: 'USD'
              });
            }
          }} data-id="element-289">
              QUIERO EL MEGA PACK
            </Button>
          </motion.div>

          {/* OPCIÓN 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-black border-2 border-gold rounded-3xl p-8 relative shadow-xl transform md:-translate-y-4" data-id="element-290">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold text-black font-bold px-6 py-1.5 rounded-full text-sm whitespace-nowrap shadow-md" data-id="element-291">
              OPCIÓN MÁS COMPLETA
            </div>

            <div className="text-center mb-6 mt-2" data-id="element-292">
              <h3 className="text-2xl font-serif font-bold text-gold mb-2" data-id="element-293">
                Mega Pack + Colección Procesos Avanzados
              </h3>
              <p className="text-cream/70 text-sm" data-id="element-294">
                Todo el sistema base más tres tomos avanzados para profundizar
                en los procesos más técnicos y rentables
              </p>
            </div>

            <ul className="space-y-3 mb-6" data-id="element-295">
              <li className="flex items-start gap-2 text-sm text-cream font-bold" data-id="element-296">
                <Check size={16} className="text-gold shrink-0 mt-0.5" data-id="element-297" />
                <span data-id="element-298">Todo lo incluido en el Mega Pack</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-cream/90" data-id="element-299">
                <Check size={16} className="text-gold shrink-0 mt-0.5" data-id="element-300" />
                <span data-id="element-301">
                  <strong className="text-gold" data-id="element-302">Tomo Avanzado 1</strong> —
                  Conservas avanzadas, mermeladas premium y fermentados · más de
                  22 recetas con formulaciones exactas por país
                </span>
              </li>
              <li className="flex items-start gap-2 text-sm text-cream/90" data-id="element-303">
                <Check size={16} className="text-gold shrink-0 mt-0.5" data-id="element-304" />
                <span data-id="element-305">
                  <strong className="text-gold" data-id="element-306">Tomo Avanzado 2</strong> —
                  Embutidos artesanales avanzados y fermentados cárnicos · 12
                  productos con formulaciones completas y análisis económico
                </span>
              </li>
              <li className="flex items-start gap-2 text-sm text-cream/90" data-id="element-307">
                <Check size={16} className="text-gold shrink-0 mt-0.5" data-id="element-308" />
                <span data-id="element-309">
                  <strong className="text-gold" data-id="element-310">Tomo Avanzado 3</strong> —
                  Lácteos premium · quesos madurados, yogur artesanal,
                  mantequilla y las 5 versiones regionales del dulce de leche
                </span>
              </li>
              <li className="flex items-start gap-2 text-sm text-cream/90" data-id="element-311">
                <Check size={16} className="text-gold shrink-0 mt-0.5" data-id="element-312" />
                <span data-id="element-313">Acceso inmediato y Garantía 7 días</span>
              </li>
            </ul>

            <div className="bg-white/5 p-3 rounded-lg border border-gold/40 text-center mb-6" data-id="element-314">
              <p className="text-sm text-cream font-medium" data-id="element-315">
                Por solo <span className="text-gold font-bold" data-id="element-316">USD 8 más</span>,
                accedés a la colección avanzada completa.
              </p>
            </div>

            <div className="text-center mb-8" data-id="element-317">
              <p className="text-4xl font-bold text-gold" data-id="element-318">USD 27,90</p>
            </div>

            <Button href="https://latam.ebookemprende.shop/cart/45952170983610:1" variant="gold" className="w-full" onLinkClick={() => {
            if (typeof window !== 'undefined' && (window as any).fbq) {
              ;
              (window as any).fbq('track', 'InitiateCheckout', {
                content_name: 'Mega Pack + Colección Procesos Avanzados',
                value: 27.9,
                currency: 'USD'
              });
            }
          }} data-id="element-319">
              LLEVAR PACK COMPLETO
            </Button>
          </motion.div>
        </div>

        <p className="text-center text-sm text-slate mt-8" data-id="element-320">
          Pagás en tu moneda local. El importe se adapta automáticamente al país
          desde donde comprás.
        </p>
      </div>
    </section>;
}